"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DeviceBrandingManifestSchema = exports.DeviceTypeSchema = exports.BrandingSlotSchema = exports.BrandingAssetType = exports.BrandingSlotName = void 0;
const zod_1 = require("zod");
exports.BrandingSlotName = zod_1.z.enum(['boot', 'login', 'loading']);
exports.BrandingAssetType = zod_1.z.enum(['image', 'video']);
exports.BrandingSlotSchema = zod_1.z.object({
    assetType: exports.BrandingAssetType,
    url: zod_1.z.string().min(1),
    fit: zod_1.z.enum(['cover', 'contain', 'fill']).default('cover'),
    opacity: zod_1.z.number().min(0).max(1).default(1),
    overlay: zod_1.z.string().optional(), // hex color layer above asset
    overlayOpacity: zod_1.z.number().min(0).max(1).optional(),
    poster: zod_1.z.string().optional(), // still frame for video
    checksum: zod_1.z.string().optional(), // sha256 hex of the asset (boot zip)
    version: zod_1.z.number().int().nonnegative(),
    publishedAt: zod_1.z.number().int().nonnegative(),
});
exports.DeviceTypeSchema = zod_1.z.enum(['android_dual_screen']); // extend per future device
exports.DeviceBrandingManifestSchema = zod_1.z.object({
    deviceType: exports.DeviceTypeSchema,
    resolution: zod_1.z.object({ width: zod_1.z.number().int().positive(), height: zod_1.z.number().int().positive() }),
    fps: zod_1.z.number().int().positive().default(15),
    bootInstallPath: zod_1.z.string().min(1),
    manifestVersion: zod_1.z.number().int().nonnegative(),
    slots: zod_1.z.object({
        boot: exports.BrandingSlotSchema.optional(),
        login: exports.BrandingSlotSchema.optional(),
        loading: exports.BrandingSlotSchema.optional(),
    }),
});
//# sourceMappingURL=deviceConfig.js.map